import { render, staticRenderFns } from "./view-proforma.html?vue&type=template&id=34990bf8&scoped=true&external"
import script from "./view-proforma.js?vue&type=script&lang=js&external"
export * from "./view-proforma.js?vue&type=script&lang=js&external"
import style0 from "./view-proforma.scss?vue&type=style&index=0&id=34990bf8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34990bf8",
  null
  
)

export default component.exports